
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wybierz-oferte",
      function () {
        return require("private-next-pages/wybierz-oferte.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wybierz-oferte"])
      });
    }
  